import { addressFragment } from '../fragments/address'

const mutation = `mutation customerAddressCreate(
    $address: CustomerAddressInput!
    $defaultAddress: Boolean
) {
    customerAddressCreate(address: $address, defaultAddress: $defaultAddress) {
        customerAddress {
          ${addressFragment}
        }
        userErrors {
            field
            message
        }
    }
}
`

export default mutation
